
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Inventory',
    empty: 'Your inventory is empty',
    emptyHint: 'Skins come from cases. Open one and it lands here.',
    emptyCta: 'Open cases',
    filtersAvailable: 'In Stock',
    filtersSold: 'Sold',
    filtersWithdrawn: 'Withdrawn',
    statusAvailable: 'Available',
    statusSold: 'Sold',
    statusProcessing: 'Processing',
    statusSent: 'Sent',
    statusConfirmed: 'Withdrawn',
    statusContractConsumed: 'Used in contract',
    statusUpgradeConsumed: 'Used in upgrade',
    loadingError: 'Failed to load inventory',
    sellAll: 'Sell All',
    confirmSellAllTitle: 'Confirm Sale',
    confirmSellAllMessage: 'Sell {{count}} items for {{amount}}?',
    confirmSellAllConfirm: 'Sell All',
    confirmSellAllCancel: 'Cancel',
    noItemsToSell: 'No items to sell',
    sellAllSuccess: 'Sold {{count}} {{word}}',
    itemOne: 'item',
    itemFew: 'items',
    itemMany: 'items',
    itemsInStock: '{{count}} {{word}} in stock',
    sellAllError: 'Failed to sell items',
    totalValue: 'Total value',
    select: 'Select',
    sellSelected: 'Sell',
    confirmSellSelectedConfirm: 'Sell',
  },
  ru: {
    title: 'Инвентарь',
    empty: 'Твой инвентарь пуст',
    emptyHint: 'Скины падают из кейсов. Открой кейс — он появится здесь.',
    emptyCta: 'Открыть кейсы',
    filtersAvailable: 'Доступно',
    filtersSold: 'Проданы',
    filtersWithdrawn: 'Выведены',
    statusAvailable: 'В наличии',
    statusSold: 'Продан',
    statusProcessing: 'Обработка',
    statusSent: 'Отправлен',
    statusConfirmed: 'Выведен',
    statusContractConsumed: 'В контракте',
    statusUpgradeConsumed: 'В апгрейде',
    loadingError: 'Не удалось загрузить инвентарь',
    sellAll: 'Продать все',
    confirmSellAllTitle: 'Подтверждение продажи',
    confirmSellAllMessage: 'Продать {{count}} предметов за {{amount}}?',
    confirmSellAllConfirm: 'Продать все',
    confirmSellAllCancel: 'Отмена',
    noItemsToSell: 'Нет предметов для продажи',
    sellAllSuccess: 'Продано {{count}} {{word}}',
    itemOne: 'предмет',
    itemFew: 'предмета',
    itemMany: 'предметов',
    itemsInStock: '{{count}} {{word}} в наличии',
    sellAllError: 'Не удалось продать предметы',
    totalValue: 'Общая стоимость',
    select: 'Выбрать',
    sellSelected: 'Продать',
    confirmSellSelectedConfirm: 'Продать',
  },
  uz: {
    title: 'Inventar',
    empty: 'Sizning inventaringiz boʻsh',
    emptyHint: 'Skinlar keyslardan tushadi. Keys ochsang, shu yerda paydo boʻladi.',
    emptyCta: 'Keyslarni ochish',
    filtersAvailable: 'Mavjud',
    filtersSold: 'Sotilgan',
    filtersWithdrawn: 'Chiqarilgan',
    statusAvailable: 'Mavjud',
    statusSold: 'Sotilgan',
    statusProcessing: 'Ishlanmoqda',
    statusSent: 'Yuborilgan',
    statusConfirmed: 'Chiqarilgan',
    statusContractConsumed: 'Kontraktda',
    statusUpgradeConsumed: 'Apgreydda',
    loadingError: 'Inventarni yuklab boʻlmadi',
    sellAll: 'Hammasini sot',
    confirmSellAllTitle: 'Sotishni tasdiqlash',
    confirmSellAllMessage: '{{count}} ta buyumni {{amount}} ga sotasizmi?',
    confirmSellAllConfirm: 'Hammasini sotish',
    confirmSellAllCancel: 'Bekor qilish',
    noItemsToSell: 'Sotish uchun buyumlar yoʻq',
    sellAllSuccess: '{{count}} ta {{word}} sotildi',
    itemOne: 'buyum',
    itemFew: 'buyum',
    itemMany: 'buyum',
    itemsInStock: '{{count}} ta {{word}} mavjud',
    sellAllError: 'Buyumlarni sotib boʻlmadi',
    totalValue: 'Umumiy qiymati',
    select: 'Tanlash',
    sellSelected: 'Sotish',
    confirmSellSelectedConfirm: 'Sotish',
  },
  fa: {
    title: 'انبار',
    empty: 'انبارت خالی است',
    emptyHint: 'اسکین‌ها از کیس می‌آیند. یکی باز کن تا همین‌جا بیفتد.',
    emptyCta: 'باز کردن کیس‌ها',
    filtersAvailable: 'موجود',
    filtersSold: 'فروخته‌شده',
    filtersWithdrawn: 'برداشت‌شده',
    statusAvailable: 'موجود',
    statusSold: 'فروخته شد',
    statusProcessing: 'در حال پردازش',
    statusSent: 'فرستاده شد',
    statusConfirmed: 'برداشت شد',
    statusContractConsumed: 'در قرارداد استفاده شد',
    statusUpgradeConsumed: 'در ارتقا استفاده شد',
    loadingError: 'انبار بارگذاری نشد',
    sellAll: 'فروش همه',
    confirmSellAllTitle: 'تأیید فروش',
    confirmSellAllMessage: '{{count}} آیتم به {{amount}} فروخته شود؟',
    confirmSellAllConfirm: 'همه را بفروش',
    confirmSellAllCancel: 'بی‌خیال',
    noItemsToSell: 'آیتمی برای فروش نیست',
    sellAllSuccess: '{{count}} {{word}} فروخته شد',
    itemOne: 'آیتم',
    itemFew: 'آیتم',
    itemMany: 'آیتم',
    itemsInStock: '{{count}} {{word}} موجود',
    sellAllError: 'آیتم‌ها فروخته نشدند',
    totalValue: 'ارزش کل',
    select: 'انتخاب',
    sellSelected: 'بفروش',
    confirmSellSelectedConfirm: 'بفروش',
  },
  pt: {
    title: 'Inventário',
    empty: 'Seu inventário está vazio',
    emptyHint: 'As skins vêm das caixas. Abra uma caixa — a skin aparece aqui.',
    emptyCta: 'Abrir caixas',
    filtersAvailable: 'Disponíveis',
    filtersSold: 'Vendidos',
    filtersWithdrawn: 'Sacados',
    statusAvailable: 'Disponível',
    statusSold: 'Vendido',
    statusProcessing: 'Processando',
    statusSent: 'Enviado',
    statusConfirmed: 'Sacado',
    statusContractConsumed: 'Usado em contrato',
    statusUpgradeConsumed: 'Usado em upgrade',
    loadingError: 'Não foi possível carregar o inventário',
    sellAll: 'Vender tudo',
    confirmSellAllTitle: 'Confirmar venda',
    confirmSellAllMessage: 'Vender {{count}} itens por {{amount}}?',
    confirmSellAllConfirm: 'Vender tudo',
    confirmSellAllCancel: 'Cancelar',
    noItemsToSell: 'Nenhum item para vender',
    sellAllSuccess: 'Vendido: {{count}} {{word}}',
    itemOne: 'item',
    itemFew: 'itens',
    itemMany: 'itens',
    itemsInStock: '{{count}} {{word}} disponíveis',
    sellAllError: 'Não foi possível vender os itens',
    totalValue: 'Valor total',
    select: 'Selecionar',
    sellSelected: 'Vender',
    confirmSellSelectedConfirm: 'Vender',
  },
  tr: {
    title: 'Envanter',
    empty: 'Envanterin boş',
    emptyHint: 'Skinler kasalardan düşer. Bir kasa aç — skin burada görünür.',
    emptyCta: 'Kasa aç',
    filtersAvailable: 'Mevcut',
    filtersSold: 'Satılanlar',
    filtersWithdrawn: 'Çekilenler',
    statusAvailable: 'Mevcut',
    statusSold: 'Satıldı',
    statusProcessing: 'İşleniyor',
    statusSent: 'Gönderildi',
    statusConfirmed: 'Çekildi',
    statusContractConsumed: 'Kontratta kullanıldı',
    statusUpgradeConsumed: "Upgrade'de kullanıldı",
    loadingError: 'Envanter yüklenemedi',
    sellAll: 'Hepsini sat',
    confirmSellAllTitle: 'Satışı onayla',
    confirmSellAllMessage: '{{count}} eşya {{amount}} karşılığında satılsın mı?',
    confirmSellAllConfirm: 'Hepsini sat',
    confirmSellAllCancel: 'İptal',
    noItemsToSell: 'Satılacak eşya yok',
    sellAllSuccess: '{{count}} {{word}} satıldı',
    itemOne: 'eşya',
    itemFew: 'eşya',
    itemMany: 'eşya',
    itemsInStock: '{{count}} {{word}} mevcut',
    sellAllError: 'Eşyalar satılamadı',
    totalValue: 'Toplam değer',
    select: 'Seç',
    sellSelected: 'Sat',
    confirmSellSelectedConfirm: 'Sat',
  },
  uk: {
    title: 'Інвентар',
    empty: 'Твій інвентар порожній',
    emptyHint: 'Скіни випадають із кейсів. Відкрий кейс — він з’явиться тут.',
    emptyCta: 'Відкрити кейси',
    filtersAvailable: 'Доступно',
    filtersSold: 'Продані',
    filtersWithdrawn: 'Виведені',
    statusAvailable: 'В наявності',
    statusSold: 'Продано',
    statusProcessing: 'Обробка',
    statusSent: 'Надіслано',
    statusConfirmed: 'Виведено',
    statusContractConsumed: 'У контракті',
    statusUpgradeConsumed: 'В апгрейді',
    loadingError: 'Не вдалося завантажити інвентар',
    sellAll: 'Продати все',
    confirmSellAllTitle: 'Підтвердження продажу',
    confirmSellAllMessage: 'Продати {{count}} предметів за {{amount}}?',
    confirmSellAllConfirm: 'Продати все',
    confirmSellAllCancel: 'Скасувати',
    noItemsToSell: 'Немає предметів для продажу',
    sellAllSuccess: 'Продано {{count}} {{word}}',
    itemOne: 'предмет',
    itemFew: 'предмети',
    itemMany: 'предметів',
    itemsInStock: '{{count}} {{word}} в наявності',
    sellAllError: 'Не вдалося продати предмети',
    totalValue: 'Загальна вартість',
    select: 'Вибрати',
    sellSelected: 'Продати',
    confirmSellSelectedConfirm: 'Продати',
  },
  de: {
    title: 'Inventar',
    empty: 'Dein Inventar ist leer',
    emptyHint: 'Skins fallen aus Cases. Öffne einen Case — dann landet er hier.',
    emptyCta: 'Cases öffnen',
    filtersAvailable: 'Verfügbar',
    filtersSold: 'Verkauft',
    filtersWithdrawn: 'Ausgezahlt',
    statusAvailable: 'Verfügbar',
    statusSold: 'Verkauft',
    statusProcessing: 'In Bearbeitung',
    statusSent: 'Gesendet',
    statusConfirmed: 'Ausgezahlt',
    statusContractConsumed: 'Im Contract',
    statusUpgradeConsumed: 'Im Upgrade',
    loadingError: 'Inventar konnte nicht geladen werden',
    sellAll: 'Alle verkaufen',
    confirmSellAllTitle: 'Verkauf bestätigen',
    confirmSellAllMessage: '{{count}} Items für {{amount}} verkaufen?',
    confirmSellAllConfirm: 'Alle verkaufen',
    confirmSellAllCancel: 'Abbrechen',
    noItemsToSell: 'Keine Items zum Verkaufen',
    sellAllSuccess: '{{count}} {{word}} verkauft',
    itemOne: 'Item',
    itemFew: 'Items',
    itemMany: 'Items',
    itemsInStock: '{{count}} {{word}} verfügbar',
    sellAllError: 'Items konnten nicht verkauft werden',
    totalValue: 'Gesamtwert',
    select: 'Wählen',
    sellSelected: 'Verkaufen',
    confirmSellSelectedConfirm: 'Verkaufen',
  },
  es: {
    title: 'Inventario',
    empty: 'Tu inventario está vacío',
    emptyHint: 'Los skins salen de las cajas. Abre una y aparecerá aquí.',
    emptyCta: 'Abrir cajas',
    filtersAvailable: 'Disponibles',
    filtersSold: 'Vendidos',
    filtersWithdrawn: 'Retirados',
    statusAvailable: 'Disponible',
    statusSold: 'Vendido',
    statusProcessing: 'En proceso',
    statusSent: 'Enviado',
    statusConfirmed: 'Retirado',
    statusContractConsumed: 'En un contrato',
    statusUpgradeConsumed: 'En un upgrade',
    loadingError: 'No se pudo cargar el inventario',
    sellAll: 'Vender todo',
    confirmSellAllTitle: 'Confirmar venta',
    confirmSellAllMessage: '¿Vender {{count}} objetos por {{amount}}?',
    confirmSellAllConfirm: 'Vender todo',
    confirmSellAllCancel: 'Cancelar',
    noItemsToSell: 'No hay objetos para vender',
    sellAllSuccess: 'Vendidos {{count}} {{word}}',
    itemOne: 'objeto',
    itemFew: 'objetos',
    itemMany: 'objetos',
    itemsInStock: '{{count}} {{word}} disponibles',
    sellAllError: 'No se pudieron vender los objetos',
    totalValue: 'Valor total',
    select: 'Elegir',
    sellSelected: 'Vender',
    confirmSellSelectedConfirm: 'Vender',
  },
  pl: {
    title: 'Ekwipunek',
    empty: 'Twój ekwipunek jest pusty',
    emptyHint: 'Skiny wypadają ze skrzynek. Otwórz skrzynkę — skin pojawi się tutaj.',
    emptyCta: 'Otwórz skrzynki',
    filtersAvailable: 'Dostępne',
    filtersSold: 'Sprzedane',
    filtersWithdrawn: 'Wypłacone',
    statusAvailable: 'Dostępny',
    statusSold: 'Sprzedany',
    statusProcessing: 'W trakcie',
    statusSent: 'Wysłany',
    statusConfirmed: 'Wypłacony',
    statusContractConsumed: 'W kontrakcie',
    statusUpgradeConsumed: 'W upgradzie',
    loadingError: 'Nie udało się załadować ekwipunku',
    sellAll: 'Sprzedaj wszystko',
    confirmSellAllTitle: 'Potwierdzenie sprzedaży',
    confirmSellAllMessage: 'Sprzedać {{count}} przedmiotów za {{amount}}?',
    confirmSellAllConfirm: 'Sprzedaj wszystko',
    confirmSellAllCancel: 'Anuluj',
    noItemsToSell: 'Brak przedmiotów do sprzedaży',
    sellAllSuccess: 'Sprzedano {{count}} {{word}}',
    itemOne: 'przedmiot',
    itemFew: 'przedmioty',
    itemMany: 'przedmiotów',
    itemsInStock: 'Dostępne: {{count}} {{word}}',
    sellAllError: 'Nie udało się sprzedać przedmiotów',
    totalValue: 'Łączna wartość',
    select: 'Wybierz',
    sellSelected: 'Sprzedaj',
    confirmSellSelectedConfirm: 'Sprzedaj',
  },
});
